<ion-grid>
  <ion-row class="isVertical" *ngIf="isVertical">
    <ion-col size="12">
      <h1>
        <ion-icon
          (click)="sumQuantity(step)"
          name="chevron-up-outline"
          color="primary"
          size="large"
          [ngClass]="{ disable: quantity === this.max }"
        ></ion-icon>
      </h1>
    </ion-col>
  </ion-row>
  <ion-row class="bet">
    <ion-col *ngIf="!isVertical" size="3">
      <ion-icon
        [color]="isTrashVisible ? (disabled ? 'medium' : 'danger') : disabled ? 'medium' : 'primary'"
        [ngClass]="{ disable: (quantity === min && !showTrash) || disabled }"
        (click)="!disabled && !noDraw && sumQuantity(step * -1)"
        [name]="isTrashVisible ? 'trash-outline' : 'remove-circle-outline'"
      ></ion-icon>
    </ion-col>
    <ion-col [size]="isVertical ? 12 : 6" [ngClass]="{ isVertical: isVertical }">
      <ion-item *ngIf="isInput" lines="none" class="quantity">
        <ion-input
          #input
          aria-label="Quantity"
          [value]="quantity"
          (ionChange)="changeQuantityInput(input, $event)"
        ></ion-input>
      </ion-item>
      <h3 *ngIf="!isInput" class="ion-text-center">{{ quantity }}</h3>
    </ion-col>
    <ion-col *ngIf="!isVertical" size="3">
      <ion-icon
        [ngClass]="{ disable: (!showMaxMessage && quantity === max) || disabled }"
        [color]="disabled ? 'medium' : showMaxMessage && quantity === max ? 'secondary' : 'primary'"
        (click)="(!disabled && !noDraw && sumQuantity(step)) || isBloc"
        [name]="showMaxMessage && quantity === max ? 'help-circle-outline' : 'add-circle-outline'"
      ></ion-icon>
    </ion-col>
  </ion-row>
  <ion-row class="isVertical" *ngIf="isVertical">
    <ion-col size="12">
      <h1>
        <ion-icon
          (click)="sumQuantity(step * -1)"
          name="chevron-down-outline"
          color="primary"
          size="large"
          [ngClass]="{ disable: quantity === this.min && !showTrash }"
        ></ion-icon>
      </h1>
    </ion-col>
  </ion-row>
</ion-grid>
